import React from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from '../Auth/AuthLayout';

export default function NotFound() {
  return (
    <AuthLayout title="Page not found">
      <p style={{ color: '#555' }}>
        404 — the page you're looking for doesn't exist, or the link may be broken.
      </p>
      <p className="mt-3">
        <Link to="/">Back to home</Link>
        {' · '}
        <Link to="/sign-in">Sign in</Link>
      </p>
    </AuthLayout>
  );
}
